var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg24IcChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2259615,3 C19.7163486,3 20.1346137,3.17307519 20.4807692,3.51923077 C20.8269248,3.86538635 21,4.28365139 21,4.77403846 L21,15.5913462 C21,16.0817332 20.8269248,16.5072097 20.4807692,16.8677885 C20.1346137,17.2283672 19.7163486,17.4086538 19.2259615,17.4086538 L6.59134615,17.4086538 L3,21 L3,4.77403846 C3,4.28365139 3.17307519,3.86538635 3.51923077,3.51923077 C3.86538635,3.17307519 4.28365139,3 4.77403846,3 L19.2259615,3 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24IcChat);
export default __webpack_public_path__ + "static/media/24_ic_chat.b74bbcc1.svg";
export { ForwardRef as ReactComponent };